import { pointerWithin, rectIntersection } from '@dnd-kit/core';

/**
 * Collision detection for the project / closing kanbans.
 *
 * Every card is a `useSortable`, so cards are drop targets too. `closestCenter` compares
 * distances between *centres*, which on a populated board almost always resolves to some
 * card rather than a column — frequently a card in a column the pointer is not even over,
 * and increasingly so the taller the column. Resolving by where the pointer actually sits
 * removes that whole class of wrong-column drops.
 *
 * A card is nested inside its column, so both collide on any hit. We prefer the column:
 * it is the unambiguous target, and it means a drop never has to be mapped back from a
 * card to the step it belongs to.
 *
 * `rectIntersection` is the fallback for when the pointer is outside every droppable
 * mid-drag (fast drags, or dragging past the edge of the board), where `pointerWithin`
 * returns nothing at all and the drop would otherwise be dropped on the floor.
 *
 * @param {string[]} columnIds droppable ids registered by the columns
 */
export const makeKanbanCollisionDetection = (columnIds) => (args) => {
  const pointerCollisions = pointerWithin(args);
  const collisions = pointerCollisions.length > 0 ? pointerCollisions : rectIntersection(args);
  const column = collisions.find(c => columnIds.includes(String(c.id)));
  return column ? [column] : collisions;
};
